import React, { useState, useEffect, useCallback } from 'react';
import { throttle } from 'lodash';
import { hooks as commonHooks } from '@sitebuilder/common';

interface PropsShape {
    searchLabel: string;
    searchTitle: string;
    value: string;
    onChange: (newValue: string) => void;
    dataContext: any;
}

export default function SearchBox(props: PropsShape) {
    const i18n = commonHooks.useLocalization();
    const label =
        (i18n.format(props?.searchLabel, props.dataContext) as string) ||
        (i18n.translate('widgets_fundList_filters_search') as string);
    const title =
        (i18n.format(props?.searchTitle, props.dataContext) as string) ||
        (i18n.translate('widgets_fundList_filters_searchHeader') as string);
    const [value, setValue] = useState(props.value || '');

    // Update our internal copy of `value` when props change
    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    // Call props.onChange when user types, but not more frequently than once every 100ms.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledOnChange = useCallback(
        throttle((newValue) => props.onChange(newValue), 500),
        [props.onChange]
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setValue(newValue);
        throttledOnChange(newValue);
    };

    return (
        <label id="search-input-label" className="search-input-wrapper">
            <span className="search-input-label-text">{title}</span>
            {!value && <i className="serach-icon fas fa-search" />}
            <input
                className="text-input filter-search-input"
                type="text"
                value={value}
                aria-label={label}
                placeholder={`${label}`}
                onChange={handleChange}
            />
        </label>
    );
}
